import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { REQUEST_KEY } from "@/react/hooks/useUpdateSpaceMember";

export const useSpaceMember = ({ spaceId, memberId }) =>
  useQuery([REQUEST_KEY, memberId], () =>
    reactQueryGet(internalApi.spaceMembers.show({ spaceId, memberId })),
  );
